import Vue from "vue";
import VueI18n from "vue-i18n";

import es from "./locales/es.json";
import en from "./locales/en.json"

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'es',
    messages: {
        es: es,
        en: en
    }
})

// Keep <html lang> in sync with the active locale. It was hardcoded to "en"
// regardless of locale, which mismatches the mostly-Spanish default content and
// can make browsers offer to auto-translate an already-correct page -- garbling
// icon-font ligatures (e.g. "schedule", "account_circle") into nonsense text.
document.documentElement.setAttribute('lang', i18n.locale);
i18n.vm.$watch('locale', (newLocale) => {
    document.documentElement.setAttribute('lang', newLocale);
});

export default i18n